import type { ReactNode } from "react";

/** Label + value line of the card panel. */
export const FieldRow = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="grid grid-cols-[7rem_1fr] items-center gap-2 text-sm">
    <span className="text-muted-foreground">{label}</span>
    <div className="min-w-0">{children}</div>
  </div>
);
